import { render, staticRenderFns } from "./NameValue.vue?vue&type=template&id=566e7b5b"
import script from "./NameValue.vue?vue&type=script&lang=js"
export * from "./NameValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports